import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';
import Big from 'big.js';
import localForage from 'localforage';
import Auth from '@js/plugins/auth';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const store = localForage.createInstance({
    storeName: `till_summary_${Auth.user().id}`,
    namespaced: true,
});

const Laroute = require('../../laroute');

store.getItem('filters').then(filters => {
    if (filters) {
        state.filters = filters;
    }
});

const state = {
    searchMeta: null,
    filters: [],
    tillSummary: {
        id: null,
        cash_adjustments: [],
        opening_amount: 0,
        closing_amount: 0,
        receipts: [],
        total_sales: 0,
        sales: 0,
        total_rounding: 0,
        sales_filter: {},
        voided_sales_filter: {},
        voided_item: {},
        topup_sales: [],
        fuel_sales: [],
        card_sales: [],
        payment_type: [],
        voided_payment: [],
        sales_refund: [],
        subsidy: [],
        version: null,
    },
};

const mutations = {
    [type.SET_TILL_SUMMARY](state, tillSummary) {
        state.tillSummary = tillSummary;
    },

    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    async setFilters(state, filters) {
        state.filters = filters;
        await store.setItem('filters', filters);
    },
};

const getters = {
    hasTillSummary(state) {
        return state.tillSummary.id !== null;
    },

    tillSummary(state) {
        return state.tillSummary;
    },

    staff(state) {
        return state.tillSummary.staff;
    },

    outlet(state) {
        return state.tillSummary.outlet;
    },

    tillList(state) {
        return state.tillSummary.tills;
    },

    sales() {
        return state.tillSummary.sales_filter.sales;
    },

    sales_refund() {
        return state.tillSummary.sales_refund;
    },

    fuelRefund() {
        return state.tillSummary.fuel_refund;
    },

    totalFuelRounding(state, getters) {
        let totalRefund = 0;
        if (_.isEmpty(state.tillSummary.summary)) {
            const rounding = state.tillSummary.sales_filter.rounding;
            const refund_rounding = Big(getters.sales_refund.rounding);
            totalRefund = Big(rounding).plus(Big(refund_rounding));
        } else {
            totalRefund = state.tillSummary.cash_sales.rounding;
        }

        return totalRefund;
    },

    voidedFuelSales() {
        return state.tillSummary.voided_sales_filter.voided_sales;
    },

    totalFuelVoidedOrders() {
        return state.tillSummary.voided_item.total_voided_order;
    },

    totalnonroyalty() {
        return state.tillSummary.nonroyalty;
    },

    voidedFuelOrders() {
        return state.tillSummary.voided_item.voided_order;
    },

    voidedNonCash() {
        if (_.isEmpty(state.tillSummary.summary)) {
            return {
                voided_sales: 0,
                total_voided: 0,
            };
        }
        return state.tillSummary.voidednoncash;
    },

    voidedTopupEdc() {
        if (_.isEmpty(state.tillSummary.summary)) {
            return {
                voided_sales: 0,
                total_voided: 0,
            };
        }
        return state.tillSummary.voidedtopupedc;
    },

    voidedTopupCash() {
        if (_.isEmpty(state.tillSummary.summary)) {
            return {
                voided_sales: 0,
                total_voided: 0,
            };
        }
        return state.tillSummary.voidedtopupcash;
    },

    voidedFuelCash() {
        if (_.isEmpty(state.tillSummary.summary)) {
            return {
                voided_sales: 0,
                total_voided: 0,
            };
        }
        return state.tillSummary.voidedcash;
    },

    checkVoid() {
        if (_.isEmpty(state.tillSummary.summary)) {
            return false;
        }
        return state.tillSummary.checkvoid;
    },

    version() {
        if (_.isNull(state.tillSummary.version)) {
            return null;
        }

        return state.tillSummary.version;
    },

    topupList() {
        return state.tillSummary.topup_sales;
    },

    subsidyList() {
        return state.tillSummary.subsidy;
    },

    partialrefund() {
        return state.tillSummary.partialrefund;
    },

    topupVoidedList() {
        return state.tillSummary.topup_voided_sales;
    },

    fuelList() {
        return state.tillSummary.fuel_sales;
    },

    cardList() {
        return state.tillSummary.card_sales;
    },

    cardEDCList() {
        return state.tillSummary.card_edc_sales;
    },

    paymentList() {
        return state.tillSummary.payment_type;
    },

    voidedList() {
        return state.tillSummary.voided_payment;
    },

    drawerOpen() {
        return state.tillSummary.drawerOpen;
    },

    pump_test() {
        return state.tillSummary.pump_test;
    },

    shortOrExtra() {
        return state.tillSummary.shortOrExtra;
    },

    negative_transaction() {
        return state.tillSummary.negative_transaction;
    },

    overrun() {
        return state.tillSummary.overrun;
    },

    cancelled_cart() {
        return state.tillSummary.cancelled_transaction_cart;
    },

    cancelled_item() {
        return state.tillSummary.cancelled_transaction_item;
    },

    cashSales() {
        return state.tillSummary.cash_sales;
    },

    setelSales() {
        if (_.isEmpty(state.tillSummary.setel_sales)) {
            return {
                total: 0,
                amount: 0,
            };
        }
        return state.tillSummary.setel_sales;
    },

    eWalletSales() {
        if (_.isEmpty(state.tillSummary.ewallet_sales)) {
            return {
                total: 0,
                amount: 0,
            };
        }
        return state.tillSummary.ewallet_sales;
    },

    virtualSmartpay() {
        if (_.isEmpty(state.tillSummary.virtualSmartpay)) {
            return {
                total: 0,
                amount: 0,
            };
        }
        return state.tillSummary.virtualSmartpay;
    },

    setelWallet() {
        if (_.isEmpty(state.tillSummary.setelWallet)) {
            return {
                total: 0,
                amount: 0,
            };
        }
        return state.tillSummary.setelWallet;
    },

    passthruSmartpay() {
        if (_.isEmpty(state.tillSummary.passthruSmartpay)) {
            return {
                total: 0,
                amount: 0,
            };
        }
        return state.tillSummary.passthruSmartpay;
    },

    cardlessGiftcard() {
        if (_.isEmpty(state.tillSummary.cardlessGiftcard)) {
            return {
                total: 0,
                amount: 0,
            };
        }
        return state.tillSummary.cardlessGiftcard;
    },

    forecourt() {
        if (_.isEmpty(state.tillSummary.summary)) {
            return {
                pay_at_forecourt_count: 0,
                pay_at_forecourt_amount: 0,
            };
        }
        return state.tillSummary.forecourt;
    },

    localAccountSales() {
        if (_.isEmpty(state.tillSummary.local_account_sales)) {
            return {
                total: 0,
                amount: 0,
            };
        }
        return state.tillSummary.local_account_sales;
    },

    cardIPTSales() {
        return state.tillSummary.card_sales_payment_ipt;
    },

    cardOPTSales() {
        return state.tillSummary.card_sales_payment_opt;
    },

    cardlessMesraSales() {
        return state.tillSummary.cardless_mesra_sales_payment;
    },

    qrSales() {
        return state.tillSummary.qr_sales;
    },

    voucherList() {
        return state.tillSummary.voucher_sales;
    },

    voidedCash() {
        return state.tillSummary.voided_cash;
    },

    receipts() {
        return state.tillSummary.receipts;
    },

    cashInFuel() {
        return state.tillSummary.cashIn;
    },

    safeDrop() {
        return state.tillSummary.safeDrop;
    },

    cashOutFuel() {
        return state.tillSummary.cashOut;
    },

    cstore() {
        return state.tillSummary.cstore;
    },

    promotionList() {
        return state.tillSummary.promotions;
    },

    priceoverride() {
        return state.tillSummary.priceoverride;
    },

    settlements() {
        return state.tillSummary.settlements;
    },

    exception() {
        if (_.isEmpty(state.tillSummary.summary)) {
            return {
                amount: 0,
                count: 0,
            };
        }
        return {
            amount: state.tillSummary.exception.amount,
            count: state.tillSummary.exception.count,
        };
    },

    totalSettlement(state, getters) {
        const totalSettlement = getters.settlements
            .map(d => d.sales_amount)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);
        return {
            total_amount: Big(totalSettlement).toFixed(2),
        };
    },

    totalSubsidy(state, getters) {
        const totalSubsidyAmount = getters.subsidyList
            .map(d => d.amount)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        const totalSubsidyVolume = getters.subsidyList
            .map(d => d.volume)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(totalSubsidyAmount).toFixed(2),
            total: Big(totalSubsidyVolume).toString(),
        };
    },

    totalTopup(state, getters) {
        const totalTopup = getters.topupList
            .map(d => d.amount_topup)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        const totalTopupQty = getters.topupList
            .map(d => d.total_topup)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        const totalNonRoyaltyQuantity = Big(
            getters.totalnonroyalty.total_quantity,
        ).plus(Big(totalTopupQty));

        const totalNonRoyaltyAmount = Big(
            getters.totalnonroyalty.total_amount,
        ).plus(Big(totalTopup));

        return {
            amount: Big(totalNonRoyaltyAmount).toFixed(2),
            total: Big(totalNonRoyaltyQuantity).toString(),
        };
    },

    fuelRefundTotal(state, getters) {
        const totalRefund = getters.fuelRefund
            .map(d => d.total_amount)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(totalRefund).toFixed(2),
        };
    },

    totalFuel(state, getters) {
        const totalFuel = getters.fuelList
            .map(d => d.amount)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        const totalFuelQty = getters.fuelList
            .map(d => d.volume)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(totalFuel).toFixed(2),
            total: Big(totalFuelQty).toFixed(3),
        };
    },

    totalCard(state, getters) {
        const totalCard = getters.cardList
            .map(d => d.amount_card_sales)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(totalCard).toFixed(2),
        };
    },

    totalEDCCard(state, getters) {
        const totalCard = getters.cardEDCList
            .map(d => d.amount_card_sales)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        const countCard = getters.cardEDCList
            .map(d => d.total_card_sales)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(totalCard).toFixed(2),
            total: countCard,
        };
    },

    totalPayment(state, getters) {
        const totalPayment = getters.paymentList
            .map(d => d.amount)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(totalPayment).toFixed(2),
        };
    },

    totalVoided(state, getters) {
        const totalVoided = getters.voidedList
            .map(d => d.amount)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return {
            amount: Big(totalVoided).toFixed(2),
        };
    },

    totalFuelSales(state, getters) {
        let totalSalesR = 0;
        if (_.isEmpty(state.tillSummary.summary)) {
            const totalCStore = getters.cstore.total_amount;

            const totalFuel = getters.fuelList
                .map(d => d.amount)
                .reduce((a, b) => Big(a).plus(Big(b)), 0);

            const totalSales = Big(totalCStore).plus(Big(totalFuel));
            totalSalesR = Big(totalSales).plus(
                Big(getters.sales_refund.total_sales),
            );
        } else {
            totalSalesR = state.tillSummary.total_sales;
        }

        return totalSalesR;
    },

    /** Sum total (RM) of voided orders */
    voidedOrders(state, getters) {
        const voidedOrders = getters.nonVoidedReceipts
            .map(r => {
                return r.transaction.order.products
                    .filter(p => p.voided_at !== null)
                    .map(p => Big(p.unit_price).times(p.quantity));
            })
            .filter(voidedOrders => voidedOrders.length)
            .reduce((a, b) => {
                const voidedAmount = b.reduce((a, b) => Big(a).plus(Big(b)), 0);
                return Big(a).plus(Big(voidedAmount));
            }, 0);

        return Big(voidedOrders).toFixed(2);
    },

    totalVoidedOrders(state, getters) {
        return getters.nonVoidedReceipts
            .map(r => {
                let totalVoided = r.transaction.order.products
                    .filter(p => p.voided_at !== null)
                    .map(p => {
                        return parseInt(p.quantity);
                    })
                    .reduce((a, b) => a + b, 0);

                return totalVoided;
            })
            .reduce((a, b) => a + b, 0);
    },

    cancelledOrders(state, getters) {
        const cancelledOrders = getters.nonVoidedReceipts
            .map(r => {
                return r.transaction.order.products
                    .filter(p => p.cancelled_at !== null)
                    .map(p => Big(p.unit_price).times(p.quantity));
            })
            .filter(cancelledOrders => cancelledOrders.length)
            .reduce((a, b) => {
                const cancelledAmount = b.reduce(
                    (a, b) => Big(a).plus(Big(b)),
                    0,
                );
                return Big(a).plus(Big(cancelledAmount));
            }, 0);

        return Big(cancelledOrders).toFixed(2);
    },

    totalCancelledOrders(state, getters) {
        return getters.nonVoidedReceipts
            .map(r =>
                r.transaction.order.products
                    .filter(p => p.cancelled_at !== null)
                    .map(p => {
                        return parseInt(p.quantity);
                    })
                    .reduce((a, b) => a + b, 0),
            )
            .reduce((a, b) => a + b, 0);
    },

    nonVoidedReceipts(state, getters) {
        return getters.receipts.filter(r => r.voided_at === null);
    },

    voidedReceipts(state, getters) {
        return getters.receipts.filter(r => r.voided_at !== null);
    },

    voidedSales(state, getters) {
        return getters.voidedReceipts
            .map(r => {
                return r.total_amount;
            })
            .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
    },

    totalVoidedSales(state, getters) {
        return getters.voidedReceipts.length;
    },

    totalSales(state, getters) {
        return getters.nonVoidedReceipts
            .map(r => {
                return r.total_amount;
            })
            .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
    },

    totalPaymentChannel(state, getters) {
        const totalVoucher = getters.voucherList
            .map(d => d.amount)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        const totalcash = getters.cashSales.amount;

        const totalIPT = getters.cardIPTSales.amount;

        const totalOPT = getters.cardOPTSales.amount;

        const totalCardlessMesra = getters.cardlessMesraSales.amount;

        const totalSetel = getters.setelSales.amount;

        const totalLocalAccount = getters.localAccountSales.amount;

        const totalEPS = getters.totalEDCCard.amount;

        const totalQr = getters.qrSales.amount;

        const totalEWallet = getters.eWalletSales.amount;

        const grantTotal = Big(totalVoucher)
            .plus(Big(totalcash))
            .plus(Big(totalIPT))
            .plus(Big(totalOPT))
            .plus(Big(totalCardlessMesra))
            .plus(Big(totalSetel))
            .plus(Big(totalLocalAccount))
            .plus(Big(totalEPS))
            .plus(Big(totalQr))
            .plus(Big(totalEWallet));

        return {
            total_amount: Big(grantTotal).toFixed(2),
        };
    },

    totalPromotion(state, getters) {
        const totalPromotion = getters.promotionList
            .map(d => d.total_amount)
            .reduce((a, b) => Big(a).plus(Big(b)), 0);

        return totalPromotion;
    },

    correction() {
        return state.tillSummary.correction;
    },
};

const actions = {
    getTillSummary({ commit, dispatch }, id) {
        let route = Laroute.route(
            'franchise.report.till_closure.show-tillsummary',
            {
                id,
            },
        );
        startLoading(dispatch, 'fetch-till-summary');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'fetch-till-summary');
                commit(type.SET_TILL_SUMMARY, res.data);
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-till-summary');
                throw err;
            });
    },

    getSearchMeta({ commit, dispatch }) {
        const route = Laroute.route('franchise.report.daily_sales.search.meta');

        startLoading(dispatch, 'get-tillmeta');

        return axios
            .get(route)
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-tillmeta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-tillmeta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ commit, dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/till-summary.js